import { render, staticRenderFns } from "./DashboardTable.vue?vue&type=template&id=0f335ee4&scoped=true&"
import script from "./DashboardTable.vue?vue&type=script&lang=js&"
export * from "./DashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTable.vue?vue&type=style&index=0&id=0f335ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f335ee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VSpacer,VTextField,VToolbar,VToolbarTitle})
